import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

import Account from '../components/UserAccount/Account';

function Useracc() {
  return (
    <>
      <Navbar />

      <div>
        <Account />
      </div>

      <Footer />
    </>
  );
}

export default Useracc;
